package one.healthium.log_food.di

import one.healthium.featureconfig.di.featureConfigModule
import one.healthium.log_food.data.AppFoodRepository
import one.healthium.log_food.data.FoodMapper
import one.healthium.log_food.data.FoodPreloadContent
import one.healthium.log_food.data.api.FoodScanApiClient
import one.healthium.log_food.domain.FoodRepository
import one.healthium.log_food.ui.camera.CameraViewModel
import one.healthium.log_food.ui.find_food.FindFoodViewModel
import one.healthium.log_food.ui.mappers.FoodUiMapper
import one.healthium.log_food.ui.scan_results.ScanResultsViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val logFoodModule = module {
    includes(logFoodPlatformModule(), featureConfigModule)

    singleOf(::AppFoodRepository) bind FoodRepository::class
    factoryOf(::FoodMapper)
    singleOf(::FoodPreloadContent)
    singleOf(::FoodScanApiClient)

    viewModelOf(::FindFoodViewModel)
    viewModelOf(::CameraViewModel)
    viewModelOf(::ScanResultsViewModel)

    factoryOf(::FoodUiMapper)
}
